module.exports = __webpack_public_path__ + "static/media/do_you_know.ee594ef7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/do_you_know.mp3
// module id = 740
// module chunks = 0